<template>
  <Card style="min-height: 350px">
    <template v-slot:title>
      <div class="p-grid p-jc-between">
        <div class="p-col-12 p-md-8">
          <div class="p-grid p-m-0">
            <span style="padding-right: 10px"> Bovinos selecionados </span>
            <br class="hide mobile-show" />
            <div style="padding-top: 10px">
              <BovineTypeSummary :bovines="bovinesList"></BovineTypeSummary>
            </div>
          </div>
        </div>
        <div class="p-col" style="text-align: right">
          <router-link
            :to="{
              name: 'bovine.import',
              query: {
                sale: true,
              },
            }"
            style="text-decoration: none"
          >
            <Button
              label="Importar bovinos"
              class="p-button-outlined p-mr-2 import-btn"
            />
          </router-link>
          <Button
            label="Adicionar Bovinos"
            class="p-button-outlined"
            @click="selectorVisible = true"
          />
        </div>
      </div>
    </template>
    <template v-slot:content>
      <BovineDataTable
        :results="bovinesList"
        :columns="[{ field: 'actions', hide: false }]"
      >
        <template #actions="{ data }">
          <Button
            type="button"
            icon="pi pi-times"
            class="p-button-text p-button-secondary"
            @click="removeBovine(data.id)"
          ></Button>
        </template>
      </BovineDataTable>
      <BovineSelector
        v-model:visible="selectorVisible"
        @select="addBovines($event.values)"
        :defaultQuery="defaultQuery"
      ></BovineSelector>
    </template>
  </Card>
  <div class="p-col-12">
    <div class="p-grid p-jc-end p-mt-2">
      <div style="padding-right: 8px">
        <Button
          label="Voltar"
          class="p-button-outlined p-mr-2"
          @click="prevPage()"
        />
        <Button label="Avançar" @click="nextPage()" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { mapActions, mapGetters } from 'vuex';
import BovineSelector from '../../components/BovineSelector';
import BovineDataTable from '../../components/BovineDataTable';
import BovineTypeSummary from '../../components/BovineTypeSummary.vue';

export default {
  name: 'SaleBovineEdit',
  components: {
    BovineSelector,
    BovineDataTable,
    BovineTypeSummary,
  },
  data() {
    return {
      selectorVisible: false,
    };
  },
  created() {
    if (!this.buyer.name) {
      this.$emit('change-page', { index: 0 });
    }
  },
  emits: ['nextPage', 'prevPage', 'changePage'],
  computed: {
    ...mapGetters('sale', ['isBovineStepValid', 'isValueStepValid']),
    ...mapFields('sale', ['formData.bovines', 'formData.buyer']),
    defaultQuery() {
      if (!this.bovines.length) {
        return { available: true };
      }
      const ids = this.bovines.map((result) => result.bovineId);
      return {
        excludeId: ids.join(','),
        available: true,
      };
    },
    bovinesList() {
      return this.bovines.map((bovine) => bovine.bovine);
    },
  },
  methods: {
    ...mapActions('sale', ['addBovines', 'removeBovine']),
    nextPage() {
      this.$emit('next-page', { pageIndex: 1 });
    },
    prevPage() {
      this.$emit('prev-page', { pageIndex: 1 });
    },
  },
  async beforeRouteLeave(to, from, next) {
    if (
      (to.name === 'sale.create.values' && !this.isBovineStepValid) ||
      (to.name === 'sale.create.review' && !this.isValueStepValid)
    ) {
      this.$toast.add({
        severity: 'warn',
        summary: 'Atenção!',
        detail: 'Adicione os bovinos para avançar!',
        life: 3000,
      });
      next(false);
    } else {
      next();
    }
  },
};
</script>

<style scoped>
.import-btn {
  color: var(--green-700) !important;
}
</style>
